module.exports = __webpack_public_path__ + "static/img/1.c58069ab.png";